import { makeStyles } from '@material-ui/core';
import React from 'react';

interface OwnProps {
  src: string;
}

const Video: React.FunctionComponent<OwnProps> = ({ src }) => {
  const classes = useStyles();

  return (
    <video width="300" className={classes.video} controls>
      <source src={src} type="video/mp4" />
      Your browser does not support HTML video.
    </video>
  );
};

const useStyles = makeStyles(() => ({
  video: {
    height: '100%',
    display: 'flex',
  },
}));

export default Video;
